<template>
  <v-container
    fluid
  >
    <v-row>
      <v-col
        class="pb-0 pt-0"
        cols="auto"
      >
        <v-tabs
          v-model="selectedTab"
        >
          <v-tab>
            ACTIVE
          </v-tab>
          <v-tab>
            ARCHIVED
          </v-tab>
        </v-tabs>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-autocomplete
          v-model="projectId"
          label="Project"
          :items="projects"
          hide-details="true"
          item-value="id"
          item-text="name"
          clearable
        />
      </v-col>
      <v-col>
        <v-select
          v-model="categoryId"
          label="Category"
          :items="categories"
          hide-details="true"
          item-value="id"
          item-text="name"
          clearable
        >
          <template #item="{ item }">
            <v-chip
              class="mt-1 mb-1"
              small
              text-color="white"
              style="cursor: pointer; text-transform: uppercase"
              :color="item ? item.color : 'white'"
            >
              {{ item ? item.name : '' }}
            </v-chip>
          </template>
          <!-- eslint-disable-next-line vue/no-template-shadow -->
          <template #selection="{ item }">
            <v-chip
              class="mt-1 mb-1"
              small
              text-color="white"
              style="cursor: pointer; text-transform: uppercase"
              :color="item ? item.color : 'white'"
            >
              {{ item ? item.name : '' }}
            </v-chip>
          </template>
        </v-select>
      </v-col>
      <v-col>
        <v-select
          v-model="statusId"
          label="Status"
          :items="statuses"
          hide-details="true"
          item-value="id"
          item-text="name"
          clearable
        >
          <template #item="{ item }">
            <v-chip
              class="mt-1 mb-1"
              small
              text-color="white"
              style="cursor: pointer; text-transform: uppercase"
              :color="item ? item.color : 'white'"
            >
              {{ item ? item.name : '' }}
            </v-chip>
          </template>
          <!-- eslint-disable-next-line vue/no-template-shadow -->
          <template #selection="{ item }">
            <v-chip
              class="mt-1 mb-1"
              small
              text-color="white"
              style="cursor: pointer; text-transform: uppercase"
              :color="item ? item.color : 'white'"
            >
              {{ item ? item.name : '' }}
            </v-chip>
          </template>
        </v-select>
      </v-col>
      <v-col>
        <v-select
          v-model="priorityId"
          :items="priorities"
          label="Priority"
          hide-details="true"
          item-text="name"
          item-value="id"
          clearable
          placeholder="Select Priority"
        >
          <template #item="{ item }">
            <v-chip
              class="mt-1 mb-1"
              small
              text-color="white"
              style="cursor: pointer; text-transform: uppercase"
              :color="item ? item.color : 'white'"
            >
              {{ item ? item.name : '' }}
            </v-chip>
          </template>
          <!-- eslint-disable-next-line vue/no-template-shadow -->
          <template #selection="{ item }">
            <v-chip
              class="mt-1 mb-1"
              small
              text-color="white"
              style="cursor: pointer; text-transform: uppercase"
              :color="item ? item.color : 'white'"
            >
              {{ item ? item.name : '' }}
            </v-chip>
          </template>
        </v-select>
      </v-col>
      <v-col>
        <v-autocomplete
          v-model="assignedToId"
          :items="users"
          item-text="full_name"
          item-value="id"
          clearable
          hide-details="true"
          label="Assigned To"
          placeholder="Select User"
        />
      </v-col>
      <v-spacer />
      <v-col cols="auto">
        <v-btn
          class="mt-5"
          @click="syncEmails"
        >
          <v-icon class="mr-2">
            mdi-refresh
          </v-icon>
          REFRESH Emails
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card
          elevation="0"
          outlined
        >
          <v-data-table
            :headers="headers"
            :items="items"
            :footer-props="footer"
            :search="search"
            :loading="loading"
            :items-per-page="pagination.itemsPerPage"
            :server-items-length="total"
            dense
            @update:options="updateOptions"
          >
            <template #[`item.name`]="{ item }">
              <text-highlight
                :queries="search"
              >
                {{ item.name }}
              </text-highlight>
            </template>
            <template #[`item.contact`]="{ item }">
              <div class="d-flex flex-column pt-1 pb-1">
                <span class="fw600">
                  <text-highlight
                    :queries="search"
                  >
                    {{ item.contact_name ? item.contact_name : '' }}
                  </text-highlight>
                </span>
                <span>
                  <text-highlight
                    :queries="search"
                  >
                    {{ item.contact_email ? item.contact_email : '' }}
                  </text-highlight>
                </span>
                <span>
                  <text-highlight
                    :queries="search"
                  >
                    {{ item.contact_phone ? item.contact_phone : '' }}
                  </text-highlight>
                </span>
              </div>
            </template>
            <template #[`item.project_location`]="{ item }">
              <div class="d-flex flex-column pt-1 pb-1">
                <span
                  v-if="item.project"
                  class="fw600"
                >
                  <text-highlight
                    :queries="search"
                  >
                    {{ item.project ? item.project.name : '' }}
                  </text-highlight>
                </span>
                <span
                  v-else
                  class="fw600"
                  style="color: red;"
                >Project not found</span>
                <span>
                  <text-highlight
                    :queries="search"
                  >
                    {{ item.address ? item.address : '' }}
                  </text-highlight>
                </span>
              </div>
            </template>
            <template #[`item.unit_details`]="{ item }">
              <div class="d-flex flex-column">
                <span>
                  <text-highlight
                    :queries="search"
                  >
                    {{ item.tower ? `Tower: ${item.tower}` : '' }}
                  </text-highlight>
                </span>
                <span>
                  <text-highlight
                    :queries="search"
                  >
                    {{ item.floor ? `Floor: ${item.floor}` : '' }}
                  </text-highlight>
                </span>
                <span>
                  <text-highlight
                    :queries="search"
                  >
                    {{ item.unit ? `Unit: ${item.unit}` : '' }}
                  </text-highlight>
                </span>
              </div>
            </template>
            <template #[`item.categories`]="{ item }">
              <div class="d-flex flex-wrap">
                <!-- Show up to 2 chips -->
                <v-chip
                  v-for="(category) in item.categories.slice(0, 2)"
                  :key="category.id"
                  class="ma-1"
                  small
                  text-color="white"
                  style="text-transform: uppercase"
                  :color="category.color"
                >
                  {{ category.name }}
                </v-chip>

                <!-- Show tooltip chip if more categories -->
                <v-tooltip
                  v-if="item.categories.length > 2"
                  bottom
                  color="black"
                >
                  <template #activator="{ on, attrs }">
                    <v-chip
                      v-bind="attrs"
                      class="ma-1"
                      small
                      color="grey"
                      text-color="white"
                      v-on="on"
                    >
                      +{{ item.categories.length - 2 }} more
                    </v-chip>
                  </template>
                  <span>
                    {{ item.categories.slice(2).map(c => c.name).join(', ') }}
                  </span>
                </v-tooltip>
              </div>
            </template>
            <template #[`item.issue_description`]="{ item }">
              <div class="d-flex flex-column">
                <v-tooltip
                  v-if="item.job_description && item.job_description.length > 30"
                  top
                  color="black"
                >
                  <template #activator="{ on, attrs }">
                    <span
                      v-bind="attrs"
                      v-on="on"
                    >
                      <text-highlight :queries="search">
                        {{ item.job_description.slice(0, 30) + '...' }}
                      </text-highlight>
                    </span>
                  </template>
                  <span>{{ item.job_description }}</span>
                </v-tooltip>

                <span v-else>
                  <text-highlight :queries="search">
                    {{ item.job_description }}
                  </text-highlight>
                </span>
                <span
                  v-if="item.attachments && item.attachments.length > 0"
                  style="color: #1976d2; font-size: 13px;"
                >
                  <v-icon
                    style="color: #1976d2; font-size: 18px; cursor: pointer;"
                    @click="viewAttachments(item.id)"
                  >mdi-file-document-outline</v-icon>
                  <span>{{ item.attachments ? item.attachments.length : 0 }}</span>
                </span>
              </div>
            </template>
            <template #[`item.thread`]="{ item }">
              <div
                v-if="item.unread_notifications_count && item.unread_notifications_count > 0"
                class="d-flex flex-column pa-1 align-center justify-center"
                style="border-radius: 100px; background-color: lightgrey;"
              >
                <span class="fw600">{{ item.unread_notifications_count }}</span>
              </div>
            </template>
            <template #[`item.status`]="{ item }">
              <v-chip
                v-if="item.status"
                class="ma-1"
                small
                text-color="white"
                :color="item.status.color"
              >
                {{ item.status.name }}
              </v-chip>
            </template>
            <template #[`item.priority`]="{ item }">
              <v-chip
                v-if="item.priority"
                class="ma-1"
                small
                text-color="white"
                style="text-transform: uppercase"
                :color="item.priority.color"
              >
                {{ item.priority.name }}
              </v-chip>
            </template>
            <template #[`item.user_name`]="{ item }">
              <text-highlight
                :queries="search"
              >
                {{ item.user_name ? item.user_name : '' }}
              </text-highlight>
            </template>
            <template #[`item.created_at`]="{ item }">
              <text-highlight
                :queries="search"
              >
                {{ item.created_at_short }}
              </text-highlight>
            </template>

            <template #[`item.actions`]="{ item }">
              <v-btn
                v-if="item.status.id === statusIdNew && item.is_archived === 0"
                class="ml-1 mt-1 mb-1"
                :color="item.status.color"
                outlined
                small
                @click="updateStatus(item.id, statusIdInProgress)"
              >
                Request received
              </v-btn>
              <v-btn
                v-if="item.status.id === statusIdInProgress && item.is_archived === 0"
                class="ml-1 mt-1 mb-1"
                :color="item.status.color"
                outlined
                small
                @click="updateStatus(item.id, statusIdPartsOrdered)"
              >
                PARTS ORDERED
              </v-btn>
              <v-btn
                v-if="item.status.id === statusIdPartsOrdered && item.is_archived === 0"
                class="ml-1 mt-1 mb-1"
                :color="item.status.color"
                outlined
                small
                @click="openBooked(item)"
              >
                BOOK SERVICE
              </v-btn>
              <v-btn
                v-if="item.status.id === statusIdBooked && item.is_archived === 0"
                class="ml-1 mt-1 mb-1"
                :color="item.status.color"
                outlined
                small
                @click="updateStatus(item.id, statusIdCompleted)"
              >
                COMPLETE
              </v-btn>
              <v-btn
                v-if="item.status.id === statusIdSiteApproved && item.is_archived === 0"
                class="ml-1 mt-1 mb-1"
                :color="item.status.color"
                outlined
                small
                @click="item.site_approval_resume_status_id === statusIdBooked ? openBooked(item) : updateStatus(item.id, item.site_approval_resume_status_id ? item.site_approval_resume_status_id : null)"
              >
                {{ item.site_approval_resume_status ? `${getUpdateStatusButtonName(item.site_approval_resume_status_id)}` : 'RESUME' }}
              </v-btn>
              <v-btn
                class="ml-1 mr-1 mt-1 mb-1"
                color="primary"
                outlined
                small
                @click="openEdit(item.id)"
              >
                OVERVIEW
              </v-btn>
              <v-menu offset-y>
                <template #activator="{ on, attrs }">
                  <v-btn
                    class="mt-1 mb-1"
                    elevation="0"
                    fab
                    outlined
                    x-small
                    v-bind="attrs"
                    tile
                    color="primary"
                    style="border-radius: 7px; width: 28px !important; height: 28px !important;"
                    v-on="on"
                  >
                    <v-icon>
                      mdi-dots-vertical
                    </v-icon>
                  </v-btn>
                </template>
                <v-list
                  class="pa-3"
                >
                  <v-list-item v-if="item.status.id === statusIdInProgress && item.is_archived === 0">
                    <v-list-item-title
                      style="font-weight: 600;"
                      @click="updateStatus(item.id, statusIdNew)"
                    >
                      <span
                        :style="`font-size: 16px !important; color: ${item.status.color}; cursor: pointer`"
                      >CANCEL IN PROGRESS</span>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="item.status.id === statusIdPartsOrdered && item.is_archived === 0">
                    <v-list-item-title
                      style="font-weight: 600;"
                      @click="updateStatus(item.id, statusIdNew)"
                    >
                      <span
                        :style="`font-size: 16px !important; color: ${item.status.color}; cursor: pointer`"
                      >CANCEL PARTS ORDERED</span>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="item.status.id === statusIdBooked && item.is_archived === 0">
                    <v-list-item-title
                      style="font-weight: 600;"
                      @click="updateStatus(item.id, statusIdInProgress)"
                    >
                      <span
                        :style="`font-size: 16px !important; color: ${item.status.color}; cursor: pointer`"
                      >CANCEL BOOKED</span>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="item.status.id === statusIdCompleted && item.is_archived === 0">
                    <v-list-item-title
                      style="font-weight: 600;"
                      @click="updateStatus(item.id, statusIdBooked)"
                    >
                      <span
                        :style="`font-size: 16px !important; color: ${item.status.color}; cursor: pointer`"
                      >CANCEL COMPLETED</span>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="item.status.id !== statusIdWaitingSiteApproval && item.status.id !== statusIdRejected && item.is_archived === 0">
                    <v-list-item-title
                      style="font-weight: 600;"
                      @click="updateStatus(item.id, statusIdWaitingSiteApproval)"
                    >
                      <span
                        :style="`font-size: 16px !important; color: #6A1B9A; cursor: pointer`"
                      >WAITING SITE APPROVAL</span>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="item.status.id === statusIdWaitingSiteApproval && item.is_archived === 0">
                    <v-list-item-title
                      style="font-weight: 600;"
                      @click="updateStatus(item.id, statusIdSiteApproved)"
                    >
                      <span
                        :style="`font-size: 16px !important; color: #D81B60; cursor: pointer`"
                      >SITE APPROVED</span>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="item.status.id !== statusIdRejected && item.is_archived === 0">
                    <v-list-item-title
                      style="font-weight: 600;"
                      @click="openRejectForm(item)"
                    >
                      <span
                        :style="`font-size: 16px !important; color: #880E4F; cursor: pointer`"
                      >REJECT</span>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-title
                      style="font-weight: 600;"
                      @click="toggleArchive(item.id)"
                    >
                      <span
                        :style="`font-size: 16px !important; color: grey; cursor: pointer`"
                      >{{ selectedTab === 0 ? 'ARCHIVE' : 'ACTIVATE' }}</span>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-title
                      style="font-weight: 600;"
                      @click="softDelete(item.id)"
                    >
                      <span
                        :style="`font-size: 16px !important; color: red; cursor: pointer`"
                      >DELETE</span>
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <stms-item-form
      ref="stmsItemForm"
      @success="success"
    />
    <attachment-form
      ref="attachmentForm"
      :is-add="false"
      :is-delete="false"
    />
    <confirm-form ref="confirmForm" />
    <stms-reject-form
      ref="stmsRejectForm"
      @success="success"
    />
    <v-dialog
      v-model="dialogDate"
      max-width="900px"
      :persistent="true"
    >
      <v-form
        v-if="selectedItem"
        ref="form"
      >
        <v-card>
          <v-card-title>
            <span class="headline">Select a date to Book the Service</span>
          </v-card-title>
          <v-card-text>
            <v-date-picker
              v-model="bookedDate"
              :allowed-dates="allowedDates"
              :events="selectedItem.preferred_dates"
              full-width
            />
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="normal"
              class="mr-2"
              @click="dialogDate = false"
            >
              Cancel
            </v-btn>
            <v-btn
              color="primary"
              @click="submitBooked"
            >
              SUBMIT
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-container>
</template>

<script>
import StmsItemForm from '@/components/forms/stms/StmsItemForm';
import AttachmentForm from '@/components/elements/AttachmentForm';
import StmsRejectForm from '@/components/forms/stms/StmsRejectForm.vue';
import { mapState } from 'vuex';

export default {
  components: {
    StmsItemForm,
    AttachmentForm,
    StmsRejectForm,
  },
  data: () => ({
    items: [],
    headers: [
      { text: 'Id', value: 'id' },
      { text: 'Contact', value: 'contact' },
      { text: 'Project & Location', value: 'project_location' },
      { text: 'Unit Details', value: 'unit_details' },
      { text: 'Category', value: 'categories', width: '10%' },
      { text: 'Subject', value: 'issue_description' },
      { text: 'Thread', value: 'thread' },
      { text: 'Priority', value: 'priority' },
      { text: 'Assigned To', value: 'user_name' },
      { text: 'Status', value: 'status' },
      { text: 'Created At', value: 'created_at' },
      { text: 'Actions', value: 'actions', align: 'end' },
    ],
    footer: {
      'items-per-page-options': [10, 20, 50, 100, 500, 1000, -1],
    },
    selectedTab: 0,
    projectId: null,
    categoryId: null,
    statusId: null,
    priorityId: null,
    assignedToId: null,
    loading: false,
    statuses: [],
    projects: [],
    categories: [],
    priorities: [],
    users: [],
    statusIdNew: 1,
    statusIdInProgress: 2,
    statusIdBooked: 3,
    statusIdCompleted: 4,
    statusIdPartsOrdered: 5,
    statusIdRejected: 6,
    statusIdWaitingSiteApproval: 7,
    statusIdSiteApproved: 8,
    attachmentTypeIdStmsRequest: 5,
    pagination: {
      itemsPerPage: 100,
      page: 1,
    },
    total: 0,
    sort: {
      order_by_first: 'id',
      direction_sort: true,
    },
    dialogDate: null,
    bookedDate: null,
    selectedItem: null,
  }),
  computed: {
    ...mapState({
      search: (state) => state.search,
      user: 'user',
    }),

  },
  watch: {
    projectId() {
      this.get();
    },
    categoryId() {
      this.get();
    },
    statusId() {
      this.get();
    },
    priorityId() {
      this.get();
    },
    assignedToId() {
      this.get();
    },
    search() {
      this.get();
    },
    pagination() {
      this.get();
    },
    selectedTab() {
      this.get();
    },
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.get();
      this.getStatuses();
      this.getProjects();
      this.getCategories();
      this.getPriorities();
      this.getUsers();
    },

    async get() {
      this.loading = true;
      this.items = [];
      const submitModel = {
        filters: {
          project_id: this.projectId,
          category_id: this.categoryId,
          status_id: this.statusId,
          priority_id: this.priorityId,
          assigned_to_id: this.assignedToId,
          is_archived: this.selectedTab,
        },
        pagination: this.pagination,
        search: this.search,
        sort: this.sort,
      };
      const res = await this.$api.stmsRequest.read(submitModel);
      if (!res || !res.data) {
        this.$bus.$emit('showError');
        this.items = [];
        this.total = 0;
        return;
      }
      this.items = res.data;
      this.total = res.total;
      this.loading = false;
    },

    async getStatuses() {
      this.statuses = await this.$api.stmsStatus.get();
    },

    async getProjects() {
      const submitModel = {
        filters: {
          is_all: 1,
        },
      };
      const res = await this.$api.project.read(submitModel);
      const cancelCode = 3001;
      if (res === cancelCode) { return; }
      if (!res || !res.data) {
        return;
      }
      this.projects = res.data;
    },

    async getCategories() {
      this.categories = await this.$api.stmsCategory.get();
    },

    async getPriorities() {
      this.priorities = await this.$api.stmsPriority.get();
    },

    async getUsers() {
      const submitModel = {
        filters: {
          is_username: false,
          // notification_type_id: 1,
        },
      };
      const res = await this.$api.user.read(submitModel);
      const cancelCode = 3001;
      if (res === cancelCode) {
        return;
      }
      this.users = res;
    },

    async toggleArchive(id) {
      const res = await this.$api.stmsRequest.get(`archive/${id}`);
      if (!res) {
        this.$bus.$emit('showError');
        return;
      }
      this.$bus.$emit('showSuccess');
      this.get();
    },

    async softDelete(id) {
      const confirm = await this.$refs.confirmForm.open({
        title: 'Are you sure that you want to delete this record?',
      });
      if (!confirm) return;
      if (!id) return;

      const res = await this.$api.stmsRequest.delete(id);

      if (!res) {
        this.$bus.$emit('showError');
        return;
      }
      this.$bus.$emit('showSuccess');
      this.get();
    },

    async syncEmails() {
      this.$bus.$emit('loading');
      const res = await this.$api.stmsRequestNotification.get('sync-emails');
      this.$bus.$emit('loading');

      if (!res) {
        this.$bus.$emit('showError');
        return;
      }

      this.$bus.$emit('showSuccess');
      this.get();
    },

    async updateStatus(id, statusId) {
      if (!id) {
        this.$bus.$emit('showError', 'Record ID not found');
        return;
      }
      if (!statusId) {
        this.$bus.$emit('showError', 'Status not found');
        return;
      }
      const confirm = await this.$refs.confirmForm.open({
        title: 'Are you sure that you want to update the status of this record?',
      });
      if (!confirm) return;
      const res = await this.$api.stmsRequest.get(`toggle-status/${id}/${statusId}/${this.user.id}`);
      if (!res) {
        this.$bus.$emit('showError');
        return;
      }
      this.$bus.$emit('showSuccess');
      this.get();
    },

    open() {
      this.$refs.stmsItemForm.open();
    },

    openEdit(id) {
      this.$refs.stmsItemForm.open(id);
    },

    success() {
      this.get();
    },

    viewAttachments(id) {
      this.$refs.attachmentForm.open(id, this.attachmentTypeIdStmsRequest);
    },

    updateOptions(newOptions) {
      this.pagination = newOptions;
      this.sort = {
        order_by_first: newOptions.sortBy[0],
        direction_sort: newOptions.sortDesc[0],
      };
    },

    openBooked(item) {
      this.dialogDate = true;
      this.bookedDate = null;

      if (!item.preferred_dates || !item.preferred_dates.length) {
        this.selectedItem = { ...item, preferred_dates: [] };
        return;
      }

      const [start, end] = [
        item.preferred_dates[0],
        item.preferred_dates[item.preferred_dates.length - 1],
      ];

      const selectedItem = {
        ...item,
        preferred_dates: this.getDatesBetween(start, end),
      };

      this.selectedItem = selectedItem;
    },

    getDatesBetween(start, end) {
      const dates = [];
      const current = start.split('-').map(Number); // [year, month, day]
      const endDate = end.split('-').map(Number);

      while (current[2] <= endDate[2] || current[1] < endDate[1] || current[0] < endDate[0]) {
        const year = current[0];
        const month = String(current[1]).padStart(2, '0');
        const day = String(current[2]).padStart(2, '0');
        dates.push(`${year}-${month}-${day}`);

        // increment day manually
        current[2] += 1;

        // handle month/year overflow
        const daysInMonth = new Date(current[0], current[1], 0).getDate();
        if (current[2] > daysInMonth) {
          current[2] = 1;
          current[1] += 1;
          if (current[1] > 12) {
            current[1] = 1;
            current[0] += 1;
          }
        }

        // stop when we passed end
        if (`${current[0]}-${String(current[1]).padStart(2, '0')}-${String(current[2]).padStart(2, '0')}` > end) break;
      }

      return dates;
    },

    openRejectForm(item) {
      this.$refs.stmsRejectForm.open(item);
    },

    async submitBooked() {
      if (!this.bookedDate) {
        this.$bus.$emit('showError', 'Please select a date');
        return;
      }
      const submitModel = {
        booked_date: this.bookedDate,
        id: this.selectedItem.id,
        user_id: this.user.id,
      };
      const res = await this.$api.stmsRequest.store(submitModel, 'book-request');
      if (!res) {
        this.$bus.$emit('showError');
        return;
      }
      this.dialogDate = false;
      this.$bus.$emit('showSuccess');
      this.get();
    },

    allowedDates(date) {
      const d = new Date(date);
      const today = new Date();

      // Function to add business days (skip weekends)
      const addBusinessDays = (date, days) => {
        const result = new Date(date);
        let added = 0;
        while (added < days) {
          result.setDate(result.getDate() + 1);
          // const day = result.getDay();
          added++;
          // if (day !== 6 && day !== 5) { // skip Sunday & Saturday
          //   added++;
          // }
        }
        return result;
      };

      // Get date that is 14 business days ahead
      const minDate = addBusinessDays(today, 14);

      // const isWeekday = d.getDay() !== 6 && d.getDay() !== 5;
      const isAfterMinDate = d >= minDate;

      // return isWeekday && isAfterMinDate;
      return isAfterMinDate;
    },

    getUpdateStatusButtonName(statusId) {
      switch (statusId) {
        case this.statusIdInProgress:
          return 'REQUEST RECEIVED';
        case this.statusIdPartsOrdered:
          return 'PARTS ORDERED';
        case this.statusIdBooked:
          return 'BOOK SERVICE';
        case this.statusIdCompleted:
          return 'COMPLETE';
        default:
          return 'RESUME';
      }
    },
  },
};
</script>

<style scoped>
span
{
  font-size: 12px !important;
}
</style>
